/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import {Platform, StyleSheet} from 'react-native';

export default StyleSheet.create({
    container: {
    flex: 1,
        marginBottom: Platform.OS === 'web'? 0: 90,
    },
    logo: {
    flex: 1,
    width: 300,
    height: 200,
    resizeMode: 'contain',
    alignSelf: 'center',
    },
    button: {
        backgroundColor: '#00000000',
        alignSelf: 'center',
        marginTop: 20,
        height: 50,
        borderRadius: 5,
        alignItems: "center",
        justifyContent: 'center',
         width: 200,
         borderTopColor: '#cccccc',
         borderBottomColor: '#cccccc',
         borderLeftColor: '#cccccc',
         borderRightColor: '#cccccc',
         borderTopWidth: 1,
         borderBottomWidth: 1,
         borderLeftWidth: 1,
         borderRightWidth: 1,
    },

    buttonTitle: {
        color: 'white',
    },
    contactFormHeader: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 18,
    },
    actionContainer: {
    marginBottom: "10%",
    alignItems: 'center',
    },
    footerView: {
    alignItems: "center",
    },
    footerInfo: {
        alignItems: "center",
        marginBottom: "5%",
    },
    footerText: {
        color: 'lightgrey',
        fontSize: 10,
        textAlign: 'center',
    },
    footerLink: {
        color: "white",
        marginBottom: "1%",
        textDecorationLine: 'underline',
    },
    appMessage: {
    marginTop: "1%",
    color: 'white',
    fontSize: 18,
    },
    helpText: {
    color: 'white',
    fontSize: 16,
    textAlign: 'center',
    marginBottom: "1%"
    },
    socialLinks: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: 20
    },
    socialLinkSpacing: {
    marginRight: 20,
    },
    iconText: {
    color: 'white',
    fontSize: 8,
    textAlign: 'center',
    marginTop: 2,
    },
contactSupport: {
flexDirection: 'column',
justifyContent: 'space-between',
alignItems: 'center',
marginTop: "2%",
 },
 iconTextLarge: {
 fontSize: 10,
 color: 'white'
 },
 listItemText: {
 color: 'white',
 },
 bottomSheetBackground: {
 backgroundColor: 'rgba(0,0,0,.9)',
 },
})
